import React from 'react';
import { createRoot } from 'react-dom/client'; // Le chemin change ici
import './index.css';
import App from './App';

// On récupère le conteneur HTML
const container = document.getElementById('root');

// On crée la racine React
const root = createRoot(container);

// On lance le rendu
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
